/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
import IBase from './base';

// 页面退出埋点
class IPVO extends IBase {
  // 换电_个人中心
  userCenter() {
    this.pvo('switchpower_mycenter');
  }

  // 换电_购买记录
  userPackage() {
    this.pvo('switchpower_payment_history');
  }

  // 换电_购买记录_订单详情页
  userPackageOrderDetail(orderId) {
    this.pvo('switchpower_orderdetails', { orderId });
  }

  // 换电_购买记录_退款申请
  userPackageRefund(orderId) {
    this.pvo('switchpower_refundpage', { orderId });
  }

  // 换电_我的资料
  userInfo() {
    this.pvo('switchpower_myinformation');
  }

  // 换电_购买套餐
  buyPackage() {
    this.pvo('switchpower_goodslist');
  }

  // 换电_换电记录
  record() {
    this.pvo('switchpower_switch_history');
  }

  // 换电_我的电池
  myBattery() {
    this.pvo('switchpower_mybattery');
  }

  // 换电_我的保险
  myInsurance() {
    this.pvo('switchpower_myinsurance');
  }

  // 换电_我的优惠券
  userCoupon() {
    this.pvo('switchpower_mycoupon');
  }

  // 换电_我的押金详情
  depositInfo() {
    this.pvo('switchpower_mydeposit');
  }

  // 换电_押金支付页
  depositPay() {
    this.pvo('switchpower_deposit_payment');
  }

  // 新版我的押金页
  myDeposit() {
    this.pvo('switchpower_mydeposit');
  }

  // 换电_开仓页
  unlock() {
    this.pvo('switchpower_opencabinet');
  }

  // 换电_手动输码页
  manualInput() {
    this.pvo('switchpower_entercode');
  }
}

export const PVO = new IPVO();
